import { useEffect, useRef } from "react";

export const useHideDropdown = <T extends HTMLElement>(setVisible: (isVisible: boolean) => void) => {
    const dropdownRef = useRef<T>(null);
    const listener = (e: MouseEvent) => {
        if (!e.composedPath().includes(dropdownRef.current!)) {
            setVisible(false);
        }
    };
    const keyboardListener = (e: KeyboardEvent) => {
        if (e.code === "Escape") setVisible(false);
    };
    useEffect(() => {
        document.body.addEventListener("click", listener);
        document.body.addEventListener("keydown", keyboardListener);
        return () => {
            document.body.removeEventListener("click", listener);
            document.body.removeEventListener("keydown", keyboardListener);
        };
    }, [dropdownRef]);
    return dropdownRef;
};
